import React from 'react'

export default function Artist() {
  return (
    <div className="screen-container">Artist</div>
  )
}
